import styled from 'styled-components';
import { RadioButton } from '../RadioButton';

export const Container = styled.div`
  background: ${(props) => props.theme.colors.numbersMenuBackgroundColor};
  border: 0.3px solid ${(props) => props.theme.colors.diviserSmoothColor};
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => `${props.containerWidth}px`};
  z-index: 9999999;
`;

export const Head = styled.div`
  color: ${(props) => props.theme.colors.numbersMenuTextColor};
  padding: 3px;
  margin: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.diviserColor};

  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
  width: ${(props) => `${props.headWidth}px`};
  .settings-closer{
    position: absolute;
    right: 8px;
    top: 13px;
    cursor: pointer;
    font-size: 22px
  }
`;

export const InnerContainer = styled.div`
  margin: 0px 10px 10px 10px
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Radio = styled(RadioButton)`
  color: ${(props) => props.theme.colors.numbersMenuTextColor};
  padding: 3px;
  width: 40px;

  .radio-button-control {
    margin-right: 3px;
  }
`;

export const Close = styled.div`

`;

export const Clicable = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: calc(100% / 3);
  position: relative;

  &>button {
    width: 100%;
  }

  .selection-clean-btn {
    padding-top: 12px;
    cursor: pointer;
  }
`;
